import script from "./EventsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsView.vue?vue&type=script&setup=true&lang=ts"

import "./EventsView.vue?vue&type=style&index=0&id=785e6ce5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785e6ce5"]])

export default __exports__